import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4e134b1b")
const _hoisted_1 = { class: "dropdown max-h-34" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary dropdown-toggle h-100 line-height",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Filters ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}